import React, { FC, ReactElement } from "react";
import styles from "./PhotoColumn.module.css";

interface PhotoColumnProps {
  photos: { name: string; width: number; height: number }[];
  setCarousel: Function;
}

const PhotoColumn: FC<PhotoColumnProps> = ({ photos, setCarousel }) => (
  <div className={styles.PhotoColumn}>
    {photos.map((photo) => (
      <img
        key={photo.name}
        src={`/pictures/compressed/${photo.name}`}
        width={photo.width}
        height={photo.height}
        loading="lazy"
        onClick={() => setCarousel(photo.name)}
      />
    ))}
  </div>
);

export default PhotoColumn;
